<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapterNumber" id="_idParaDest-2"><a id="_idTOCAnchor-12"></a>Acknowledgments</h1>
<p class="noindent">We are deeply grateful to the fifty leading professionals who aided our investigation of the mental side of golf by responding to the questionnaire reproduced in the Appendix of this book. Without this basis in authoritative opinion Mind Over Golf might merely have added to the tangle of speculation and confusion which has always surrounded this subject. With it, however, we feel that our book can clarify many issues, settle many arguments, and bring long-needed help to every golfer.</p>
<p class="normal">We are also indebted to Harold Marcus, M.D., psychiatrist and psychoanalyst, for his valuable advice on certain technical matters.</p>
<p class="quote_right">TOM NIEPORTE</p>
<p class="quote_right">and</p>
<p class="quote_right">DON SAUERS</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MindOverGolf-2.vue?15350e9b